if (window.innerWidth >= 768) {

    setTimeout(()=>{
        let thumbnailList = document.querySelector(".product-medias__thumbnails");
        let thumbnailListHeight = thumbnailList.offsetHeight*0.8;

        thumbnailList.style.height = 0;
        let newPlaceThumbnailList = thumbnailList.closest(".product-single").parentNode;
        if (thumbnailList) {
            let thumbnailsPlug = document.createElement('div');
            thumbnailsPlug.className = 'thumbnails--plug';
            thumbnailsPlug.style.height = thumbnailListHeight + "px";
            newPlaceThumbnailList.append(thumbnailsPlug);

            let toTopThumbnailList = document.body.scrollTop + thumbnailList.offsetTop;
            let toTopNewPlace = document.body.scrollTop + thumbnailsPlug.offsetTop;
            thumbnailList.style.zIndex = 1;
            thumbnailList.style.height = 0;
            function calcPosition() {
                thumbnailList.style.transform = `translate(calc(50% + 20px), ${toTopNewPlace - toTopThumbnailList}px) scale(0.8)`;
            }
            calcPosition();
            setInterval(() => {
                thumbnailList = document.querySelector(".product-medias__thumbnails");
                thumbnailListHeight = thumbnailList.offsetHeight*0.8;
                toTopThumbnailList = document.body.scrollTop + thumbnailList.offsetTop;
                toTopNewPlace = document.body.scrollTop + thumbnailsPlug.offsetTop;
                calcPosition();
            }, 1000);
        }
    }, 1000);
} else {

    setTimeout(()=>{
        // Вставка социальных иконок после картинок в слайдере
        let thumbnailList = document.querySelector(".product-medias__thumbnails");
        let secionSocialLinks = document.querySelector(".section__social-links").parentNode;
        let secionSocialLinksHeight = secionSocialLinks.offsetHeight;
        let newPlaceSocialLinks = thumbnailList.closest(".product-single").firstChild;
        // console.log(newPlaceSocialLinks);

        if (secionSocialLinks) {
            let secionSocialLinksPlug = document.createElement('div');
            secionSocialLinksPlug.className = 'thumbnails--plug';
            secionSocialLinksPlug.style.height = secionSocialLinksHeight + "px";
            secionSocialLinksPlug.innerHTML = secionSocialLinks.innerHTML;
            newPlaceSocialLinks.append(secionSocialLinksPlug);
            secionSocialLinks.remove();
        }
    }, 500);
}

setTimeout(()=>{
    let popUpSupplement = document.querySelector(".pop-up__image-supplement--trigger");
    if (popUpSupplement) {
        let popUp = document.createElement('div');
        popUp.className = 'pop-up__image-supplement';
        popUp.innerHTML = `<div class="supplement__content">
                                <img src="https://cdn.shopify.com/s/files/1/0559/4805/0622/files/pop-up-supplements-img.jpg" height="420" width="420">
                            </div>`;
        document.body.append(popUp);


        popUpSupplement.addEventListener("click", event => {
            event.preventDefault();
            document.body.style.overflow = "hidden";
            popUp.classList.add("open");

        })
        popUp.addEventListener("click", event => {
            popUp.classList.remove("open");
            document.body.style.overflow = "visible";
        })
    }
}, 500);